/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Meerschaum Digital (https://sketchfab.com/meerschaumdigital)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/fruit-bowl-373c679b7bd644aea12373945834e973
title: Fruit Bowl
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function FruitBowlModel(props) {
  const { nodes, materials } = useGLTF("../assets/models/fruit_bowl/scene.glb");
  return (
    <group {...props} dispose={null} scale={[15, 15, 15]}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <group position={[0, 2.37, 0]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Circle_None_0.geometry}
              material={materials.None}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["Circle_None_sf66-4-7cjpg_0"].geometry}
              material={materials["None_sf66-4-7c.jpg"]}
            />
          </group>
          <group position={[-6.72, 4.57, -0.44]} rotation={[-0.06, 0.16, 0.38]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Apple_Apple_PBR_0.geometry}
              material={materials.Apple_PBR}
            />
          </group>
          <group position={[2.76, 4.45, 2.15]} rotation={[0.19, -0.1, 0.08]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Mandarin_Orange_Mandarin_Orange_PBR_0.geometry}
              material={materials.Mandarin_Orange_PBR}
            />
          </group>
          <group position={[3.67, 4.34, 3.15]} rotation={[2.13, -1.12, 0.5]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Banana_Banana_PBR_0.geometry}
              material={materials.Banana_PBR}
            />
          </group>
          <group position={[6.17, 4.19, 2.43]} rotation={[-1.4, 1.04, -0.22]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Banana001_Banana_PBR_0.geometry}
              material={materials.Banana_PBR}
            />
          </group>
          <group position={[-1.32, 1.46, -3.1]} rotation={[-0.8, 0.2, 0.2]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Pomegranate_Pomegranate_PBR_0.geometry}
              material={materials.Pomegranate_PBR}
            />
          </group>
          <group position={[4.92, 0.94, -3.98]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Peach_Peach_PBR_0.geometry}
              material={materials.Peach_PBR}
            />
          </group>
          <group
            position={[-3.36, 4.34, 7.1]}
            rotation={[-Math.PI, -1.13, -Math.PI]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Kiwi_Kiwi_PBR_0.geometry}
              material={materials.Kiwi_PBR}
            />
          </group>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("../assets/models/fruit_bowl/scene.glb");
